export const GET_CONSUMABLES_STATUS_REQUEST = "GET_CONSUMABLES_STATUS_REQUEST";
export const GET_CONSUMABLES_STATUS_FAILURE = "GET_CONSUMABLES_STATUS_FAILURE";
export const GET_CONSUMABLES_STATUS_SUCCESS = "GET_CONSUMABLES_STATUS_SUCCESS";
